import type { ActionReducerMap } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';

import {
  homebatteryAdviceFormSelectorKey,
  homebatteryAdviceFormReducer,
  homeBatteryFunnelReducer,
  homeBatteryFunnelKey,
  homeBatteryWizardReducer,
  homebatteryWizardSelectorKey,
  type HomeBatteryAdviceFormState,
  type HomeBatteryFunnelState,
  type HomeBatteryWizardState,
} from './reducers';
import {
  homebatteryQuestionnaireKey,
  homebatteryQuestionnaireReducer,
  type HomebatteryQuestionnaireState,
} from './questionnaire/homebattery-questionnaire.reducer';
import {
  homebatteryCapacityReducer,
  homebatteryCapacitySelectorKey,
  type HomeBatteryCapacityState,
} from './capacity/homebattery-capacity.reducer';

export const fehHomebatteryStoreSelectorKey = 'feh-homebattery';

export interface FehHomebatteryState {
  readonly [homebatteryAdviceFormSelectorKey]: HomeBatteryAdviceFormState;
  readonly [homeBatteryFunnelKey]: HomeBatteryFunnelState;
  readonly [homebatteryWizardSelectorKey]: HomeBatteryWizardState;
  readonly [homebatteryQuestionnaireKey]: HomebatteryQuestionnaireState;
  readonly [homebatteryCapacitySelectorKey]: HomeBatteryCapacityState;
}

export const reducers: ActionReducerMap<FehHomebatteryState> = {
  [homebatteryAdviceFormSelectorKey]: homebatteryAdviceFormReducer,
  [homeBatteryFunnelKey]: homeBatteryFunnelReducer,
  [homebatteryWizardSelectorKey]: homeBatteryWizardReducer,
  [homebatteryQuestionnaireKey]: homebatteryQuestionnaireReducer,
  [homebatteryCapacitySelectorKey]: homebatteryCapacityReducer,
};

export const selectFehHomebatteryState =
  createFeatureSelector<FehHomebatteryState>(fehHomebatteryStoreSelectorKey);
